import type { ReactNode } from "react";
import Typography from "@mui/material/Typography";

const Dd = ({ children }: { children: ReactNode }) => (
    <Typography component="dd">{children}</Typography>
);

export default Dd;
